<template>
  <v-card class="mt-5 pa-5">
    <v-card-title class="titulo_card">
      {{ $t("Calcular comisiones") }}
    </v-card-title>

    <v-card-text>
      <v-row class="ma-0">
        <v-col cols="4" v-if="data_filters.dates">
          <DatePickerRange
              v-model="data_filters.dates"
              :title="$t('Fecha')"
              outlined
              dense
          />
        </v-col>

        <v-col cols="8" class="text-end">
          <v-btn @click="get_comisiones_defecto" small right class="primary mr-1">
            <v-icon small class="mr-1">mdi-reload</v-icon>
            {{ $t("Actualizar") }}
          </v-btn>
          <v-btn @click="dialog_detalle = true" small right class="secondary">
            <v-icon small class="mr-1">mdi-eye</v-icon>
            {{ $t("Ver detalle") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-divider/>

      <v-row>
        <v-col cols="12" class="text-center">
          <v-switch v-model="show_sin_iva"
                    :label="$t('Mostrar comisión sin impuestos aplicados')"
                    dense
                    class="ma-0 d-inline-block"></v-switch>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <TablaComisionesEmpleadoPorConcepto
              :show_sin_iva="show_sin_iva"
              :items="data_comisiones.resumen"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn class="primary mx-0 my-2" small :title="$t('Exportar con iva')" @click="export_excel(true)">
            <v-icon small class="mr-1">mdi-cloud-download-outline</v-icon>
            {{ $t('Exportar con iva') }}
          </v-btn>
          <v-btn class="secondary mx-1 my-2" small :title="$t('Exportar sin iva')" @click="export_excel(false)">
            <v-icon small class="mr-1">mdi-cloud-download-outline</v-icon>
            {{ $t('Exportar sin iva') }}
          </v-btn>
          <TablaComisionesEmpleadoDetalle
              v-if="data_comisiones.resumen_detalle"
              :show_sin_iva="show_sin_iva"
              :items="data_comisiones.resumen_detalle"
          />
        </v-col>
      </v-row>

      <DialogComisionesEmpleadoDetalle
          v-if="dialog_detalle"
          v-model="dialog_detalle"
          :empleado="empleado"
          :num_clientes="data_comisiones.num_clientes"
          :items="data_comisiones.detalle_tabla"
      />
    </v-card-text>
  </v-card>
</template>


<script>
import DialogComisionesEmpleadoDetalle
  from "@/views/Configuracion/Empleados/components/DialogComisionesEmpleadoDetalle.vue";

export default {
  name: 'CalcularComisiones',

  props: {
    empleado: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    data_filters: {},
    selected_filters: {

    },
    show_sin_iva: false,

    data_comisiones: {
      resumen: [],
      resumen_detalle: null,
      detalle_tabla: null,
      num_clientes: 0
    },
    dialog_detalle: null
  }),

  methods: {

    /**
     * Busca y actualiza la lista del resumen de comisiones
     */
    async get_comisiones_defecto() {
      const result = await this.$store.dispatch("comision_empleado/resumen", {
        empleados: this.empleado.id,
        fecha_inicio: this.data_filters.dates[0],
        fecha_fin: this.data_filters.dates[1]
      })

      let lista = []
      let visto = new Set()

      Object.keys(result.resumen_detalle).forEach((current_key)=>{
        result.resumen_detalle[current_key].forEach((current_linea)=>{
          visto.add(current_linea.cliente_id)
        })

        lista = [...lista, ...result.resumen_detalle[current_key]]
      })

      result.num_clientes = visto.size
      result.detalle_tabla = result.resumen_detalle
      result.resumen_detalle = lista

      result.resumen_detalle = result.resumen_detalle.sort((a, b)=>{
        return this.$moment(b.fecha_venta) - this.$moment(a.fecha_venta)
      })

      this.data_comisiones = result
    },

    export_excel(descontar_iva=false){
      const payload = {sin_iva: descontar_iva?0:1, fecha_inicio: this.data_filters.dates[0],
        fecha_fin: this.data_filters.dates[1], empleados: this.$props.empleado.id}
      this.$store.dispatch('comision_empleado/exportar', payload)
    }
  },

  mounted() {
    // Inicializamos las fechas de los filtros
    this.data_filters.dates = [this.$moment().startOf('month').format('YYYY-MM-DD'),
      this.$moment().endOf('month').format('YYYY-MM-DD')]

    this.get_comisiones_defecto()
  },

  components: {
    DialogComisionesEmpleadoDetalle,
    TablaComisionesEmpleadoPorConcepto: () => import('@/views/Configuracion/Empleados/components/TablaComisionesEmpleadoPorConcepto'),
    TablaComisionesEmpleadoDetalle: () => import('@/views/Configuracion/Empleados/components/TablaComisionesEmpleadoDetalle')
  }
}
</script>
